export default "__VITE_ASSET__DcWAsP0t__"